import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import {
  EmployerGroupResponseData,
  EmployerSelectedDuration,
  IEmployerGroupResponseData,
} from '../pages/HomePage';

export class EmployerGroupStore {
  employerGroupResponseData: IEmployerGroupResponseData = {
    _id: '',
    risk_status: '',
    eg_nid: [],
    employer_group_name: [],
    status: '',
    plan_start_month: '',
    plan_end_month: '',
    recent_plan_year: 0,
    start_month: '',
    start_year: 0,
    end_month: '',
    end_year: 0,
    total_enrolles: 0,
    pmpm: 0,
    total_cost: 0,
    organization: '',
    assigned_to: '',
    __v: 0,
    last_updated: '',
    sic_code: '',
    industry_type: '',
    state: '',
    admin_and_premium_cost: [],
    max_claim_date: '',
    min_claim_date: '',
    max_incurred_date: '',
    min_incurred_date: '',
    network_indicator_list: [],
    is_claims_present: false,
  };
  allEmployerGroupsData: EmployerGroupResponseData[] = [];
  selectedDuration: EmployerSelectedDuration = {
    startDate: '',
    endDate: '',
  };
  selectedDashboardCategory: string = '';
  isIndividualGroup: boolean = true;
  deductibleAmount: number = 0;
  memberIdsCrossing50PercentDeductible: string[] = [];

  constructor() {
    makeObservable(this, {
      employerGroupResponseData: observable,
      allEmployerGroupsData: observable,
      selectedDuration: observable,
      setEmployerGroupResponseData: action,
      removeEmployerGroupResponseData: action,
      clearEmployerGroupStore: action,
      setAllEmployerGroupsData: action,
      setSelectedDuration: action,
      removeSelectedDuration: action,
      selectedDashboardCategory: observable,
      setSelectedDashboardCategory: action,
      clearSelectedDashboardCategory: action,
      isIndividualGroup: observable,
      deductibleAmount: observable,
      memberIdsCrossing50PercentDeductible: observable,
    });

    makePersistable(this, {
      name: 'EmployerGroupStore',
      properties: [
        'employerGroupResponseData',
        'allEmployerGroupsData',
        'selectedDuration',
        'selectedDashboardCategory',
        'isIndividualGroup',
        'deductibleAmount',
        'memberIdsCrossing50PercentDeductible',
      ],
      storage: window.localStorage,
    });
  }

  setSelectedDuration(startDate: string, endDate: string) {
    this.selectedDuration = {
      startDate: startDate,
      endDate: endDate,
    };
  }
  removeSelectedDuration() {
    this.selectedDuration = {
      startDate: '',
      endDate: '',
    };
  }

  setEmployerGroupResponseData(
    employerGroupResponseData: IEmployerGroupResponseData,
  ) {
    this.employerGroupResponseData = employerGroupResponseData;
  }

  removeEmployerGroupResponseData() {
    this.employerGroupResponseData = {
      _id: '',
      risk_status: '',
      eg_nid: [],
      employer_group_name: [],
      status: '',
      plan_start_month: '',
      plan_end_month: '',
      recent_plan_year: 0,
      start_month: '',
      start_year: 0,
      end_month: '',
      end_year: 0,
      total_enrolles: 0,
      pmpm: 0,
      total_cost: 0,
      organization: '',
      assigned_to: '',
      __v: 0,
      last_updated: '',
      sic_code: '',
      industry_type: '',
      state: '',
      admin_and_premium_cost: [],
      max_claim_date: '',
      min_claim_date: '',
      max_incurred_date: '',
      min_incurred_date: '',
      care_navigation_id: '',
      network_indicator_list: [],
      is_claims_present: false,
    };
  }

  clearEmployerGroupStore() {
    this.employerGroupResponseData = {
      _id: '',
      risk_status: '',
      eg_nid: [],
      employer_group_name: [],
      status: '',
      plan_start_month: '',
      plan_end_month: '',
      recent_plan_year: 0,
      start_month: '',
      start_year: 0,
      end_month: '',
      end_year: 0,
      total_enrolles: 0,
      pmpm: 0,
      total_cost: 0,
      organization: '',
      assigned_to: '',
      __v: 0,
      last_updated: '',
      sic_code: '',
      industry_type: '',
      state: '',
      admin_and_premium_cost: [],
      max_claim_date: '',
      min_claim_date: '',
      max_incurred_date: '',
      min_incurred_date: '',
      care_navigation_id: '',
      network_indicator_list: [],
      is_claims_present: false,
    };
  }

  setAllEmployerGroupsData(allEmployerGroupsData: EmployerGroupResponseData[]) {
    this.allEmployerGroupsData = allEmployerGroupsData;
  }

  setSelectedDashboardCategory(category: any) {
    this.selectedDashboardCategory = category;
  }

  clearSelectedDashboardCategory() {
    this.selectedDashboardCategory = '';
  }

  setIsIndividualGroup(isIndividualGroup: boolean) {
    this.isIndividualGroup = isIndividualGroup;
  }

  setDeductibleAmount(deductibleAmount: number) {
    this.deductibleAmount = deductibleAmount;
  }

  removeDeductibleAmount() {
    this.deductibleAmount = 0;
  }

  setMemberIdsCrossing50PercentDeductible(
    memberIdsCrossing50PercentDeductible: string[],
  ) {
    this.memberIdsCrossing50PercentDeductible = memberIdsCrossing50PercentDeductible;
  }

  removeMemberIdsCrossing50PercentDeductible() {
    this.memberIdsCrossing50PercentDeductible = [];
  }
}
export default EmployerGroupStore;
